// Configuración de la aplicación
export const APP_CONFIG = {
  name: 'BikeRental Admin',
  version: '0.0.1', // Esta versión se puede actualizar manualmente o leer desde package.json
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'
};

// Mapear entornos a nombres más legibles
export const ENVIRONMENT_NAMES = {
  'development': 'DEV',
  'staging': 'STAGING', 
  'production': 'PROD'
};

// Función para obtener información de versión formateada
export const getVersionInfo = (isCollapsed = false) => {
  const version = APP_CONFIG.version;
  const environment = ENVIRONMENT_NAMES[APP_CONFIG.environment] || APP_CONFIG.environment.toUpperCase();
  
  return {
    version,
    environment,
    fullText: isCollapsed ? `${version}` : `v${version} • ${environment}`,
    tooltip: `v${version} • ${environment}`
  };
}; 